import { SHOW_MODAL, HIDE_MODAL, SUBMIT_START, SUBMIT_ERROR, UPDATE_MODAL_DATA } from '../../actions/admin/modalActions';

const INIT_STATE = {
    visible: false,
    submitting: false,
    type: null,
    data: null,
};

const modalReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case SHOW_MODAL: {
            return { ...state, visible: true, submitting: false, type: action.payload.type, data: action.payload.data };
        }
        case UPDATE_MODAL_DATA: {
            return { ...state, data: action.data };
        }
        case HIDE_MODAL: {
            return { ...state, visible: false, submitting: false, type: null, data: null };
        }
        case SUBMIT_START: {
            return { ...state, submitting: true };
        }
        case SUBMIT_ERROR: {
            return { ...state, submitting: false };
        }
        default:
            return state;
    }
}

export default modalReducer;
